import React from "react";
import './Intro.css';
import Github from '../../img/github.png';
import LinkedIn from '../../img/linkedin.png';
import Instagram from '../../img/instagram.png';
import Vector1 from '../../img/Vector1.png';
import Vector2 from '../../img/Vector2.png';
import boy from '../../img/boy.png';
import thumbup from '../../img/thumbup.png';
import Crown from '../../img/crown.png';
import glasseimoji from '../../img/glassesimoji.png';
import FloatingDiv from "../FloatingDiv/FloatingDiv";
import {themeContext} from '../../Context';
import { useContext } from "react";
// import {motion} from "framer-motion"

const Intro = () => {

    const transition = {duration: 2,  type: 'spring'}

    const theme = useContext (themeContext);
    const darkMode = theme.state.darkMode;
    return (
        <div className="intro">
            <div className="i-left">
                <div className="i-name">
                    <span style = {{color: darkMode? 'white': ''}}>Hola! I'm</span>
                    <span>Mahad Sarwar</span>
                    <span>who fixes problems while drinking coffee, cuz</span>
                    <span>GREAT IDEAS COMES WITH A COFFEE!</span>
                </div>

                <button className="button i-button">Hire Me!</button>
                <div className="i-icons">
                    <a href="https://github.com/mahad001?tab=repositories" target= "blank">
                    <img src= {Github} alt = ""/>
                    </a>
                    <a href="https://www.linkedin.com/in/mahad-sarwar-4b685518a/" target= "blank">
                    <img src= {LinkedIn} alt = ""/>
                    </a>
                    
                    <img src= {Instagram} alt = ""/>
                </div>
            </div>
            <div className="i-right">
                <img src= {Vector1} alt=""/>
                <img src= {Vector2} alt=""/>
                <img src= {boy} alt=""/>
                <img
                initial = {{left: '-36%'}}
                whileInView  = {{left: '-24%'}}
                transition = {transition}
                src= {glasseimoji} 
                alt=""
                />
                <div 
                 initial = {{top: '-4%', left: '74%'}}
                 whileInView  = {{left: '68%'}}
                 transition = {transition}
                className="flt-img-r">
                    <FloatingDiv  image = {Crown} txt1 = 'Web' txt2 = 'Developer'/>
                </div>
                <div 
                 initial = {{top: '18rem', left: '9rem'}}
                 whileInView  = {{left: '0rem'}}
                 transition = {transition}
                 className="flt-img-l">
                    <FloatingDiv image = {thumbup} txt1 = 'Best Design' txt2 = 'Award'/>
                </div>
                {/* blur divs */}
                <div className="blur" style={{background: "rgb(238 210 255)"}}></div>
                <div className="blur" style={{background: '#C1F5FF', top: '17rem', width: '21rem', height: '11rem', left: '-9rem'}}></div>
            </div>
        </div>
    )
}

export default Intro